<template>
  <dropdown v-if="auth.user" class="mt-1" placement="bottom-end">
    <template #default>
      <img v-if="avatar" class="block lg:hidden ml-4 w-8 h-8 rounded-full inline-flex mr-2" :src="avatar">
      <icon v-else class="inline-block w-5 h-5 mr-2 md:-mt-1 fill-secondary-500" name="user"></icon>
      <div class="hidden lg:inline-flex group flex items-center cursor-pointer select-none">
        <div class="mr-1 text-gray-700 group-hover:text-primary-600 focus:text-primary-600 whitespace-nowrap">
          <img v-if="avatar" class="block ml-4 w-8 h-8 rounded-full inline-flex mr-2" :src="avatar">
          <span>{{ auth.user.first_name }}</span>
          <span class="hidden lg:inline">&nbsp;{{ auth.user.last_name }}</span>
        </div>
      </div>
    </template>
    <template #dropdown>
      <div class="mt-2 py-2 text-sm bg-white rounded shadow-xl">
        <Link class="block px-6 py-2 hover:text-white hover:bg-primary-500" :href="`/users/${auth.user.id}/edit`">{{ __('user.my_profile') }}</Link>
        <Link v-if="auth.user.role_id < 3" class="block px-6 py-2 hover:text-white hover:bg-primary-500" href="/users">{{ __('user.manage') }}</Link>
        <Link href="/impressum" target="_blank" class="block px-6 py-2 w-full text-left hover:text-white hover:bg-primary-500">Impressum</Link>
        <a href="/datenschutzerklaerung/" class="block px-6 py-2 w-full text-left hover:text-white hover:bg-primary-500">Datenschutz</a>
        <a href="" onclick="return klaro.show()" class="block px-6 py-2 w-full text-left hover:text-white hover:bg-primary-500">Cookie Einstellungen</a>
        <Link class="block px-6 py-2 w-full text-left hover:text-white hover:bg-primary-500" href="/logout" method="delete" as="button">{{ __('general.logout') }}</Link>
        <div class="block px-6 py-2 w-full text-left text-gray-400"><small>Version: {{ config.version }}</small></div>
      </div>
    </template>
  </dropdown>

  <Link v-else class="group flex items-center py-3" href="/login">
    <i class="fa fa-sign-in mr-2 fill-primary-500 group-hover:fill-secondary"></i>
    <div class="text-secondary-300 group-hover:text-secondary">{{ __('general.login') }}</div>
  </Link>
</template>

<script>
import Icon from '../Icon';
import {Link} from '@inertiajs/inertia-vue3'
import Dropdown from '../Dropdown'

export default {

  name: 'UserDropdown',

  components: {
    Dropdown,
    Link,
    Icon,
  },

  props: {
    config: Object,
    avatar: {
      type: String,
      required: false,
    },
    auth: {
      type: Object,
    },
  },
}
</script>

<style scoped>

</style>
